// Firebase web config for project "aimax-fi".
// NOTE: these values are PUBLIC by design (they ship in every web client) — not secrets.
// They mirror the `web` entry in mobile_app/lib/firebase_options.dart so web + mobile
// use the same Firebase project / FCM sender.
export const firebaseConfig = {
  apiKey: 'AIzaSyA_vuP_p4NioNiPwngpIHflv_5psN6jHXY',
  authDomain: 'aimax-fi.firebaseapp.com',
  projectId: 'aimax-fi',
  storageBucket: 'aimax-fi.firebasestorage.app',
  messagingSenderId: '842260695003',
  appId: '1:842260695003:web:3d0199a886a280ec40c9fe',
};

// VAPID public key (Web Push certificate) — required for getToken() in the browser.
// Get it from: Firebase Console → Project settings → Cloud Messaging → Web Push certificates → "Key pair".
// Set VITE_FIREBASE_VAPID_KEY in .env / .env.production. Without it, web push token registration is skipped.
export const FIREBASE_VAPID_KEY =
  (import.meta as ImportMeta & { env: Record<string, string | undefined> }).env
    .VITE_FIREBASE_VAPID_KEY ?? '';

// Keep in sync with the importScripts() version in public/firebase-messaging-sw.js
export const FIREBASE_SDK_VERSION = '12.14.0';
